module.exports = __webpack_public_path__ + "img/01.043cf182.jpg";